import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import moiPay from '../assets/logo/logo.png';
import bgGif from '../assets/team/bg.gif';
import { PathsUrls } from '../utils/path_url';
import {
  Box,
  Button,
  Stack,
  AppBar,
  Toolbar,
  IconButton,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';

const menuItems = [
  { label: 'Home', route: PathsUrls.home },
  { label: 'About Us', route: PathsUrls.about },
  { label: 'Blogs', route: PathsUrls.blog },
  { label: 'The Team', route: PathsUrls.ourTeam },
  { label: 'Contact Us', route: PathsUrls.contactUs },
];

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const [activeItem, setActiveItem] = useState(location.pathname);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 768) setMenuOpen(false);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleNavClick = (route) => {
    navigate(route);
    setActiveItem(route);
    setMenuOpen(false);
  };

  return (
    <AppBar
      position="relative"
      sx={{
        backgroundColor: 'black',
        boxShadow: 'none',
        height: '100px',
      }}
    >
      <Toolbar
        sx={{
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          px: { xs: 3, md: 12 },
        }}
      >
        {/* Blue Glow */}
        <Box
          sx={{
            position: 'absolute',
            width: '100%',
            height: '100%',
            top: '-20%',
            left: 0,
            background:
              'radial-gradient(50% 50% at 50% 0%, rgba(94,176,239,0.5) 0%, rgba(255,255,255,0) 100%)',
            zIndex: 0,
          }}
        />

        {/* Logo */}
        <Box
          component="img"
          src={moiPay}
          alt="MOI PAY"
          sx={{
            width: { xs: 50, md: 55 },
            height: 50,
            cursor: 'pointer',
            zIndex: 2,
          }}
          onClick={() => navigate(PathsUrls.home)}
        />

        {/* Desktop Menu */}
        <Stack
          direction="row"
          spacing={6}
          sx={{
            display: { xs: 'none', md: 'flex' },
            position: 'absolute',
            left: '50%',
            transform: 'translateX(-50%)',
            zIndex: 2,
          }}
        >
          {menuItems.map((item) => (
            <Button
              key={item.label}
              onClick={() => handleNavClick(item.route)}
              sx={{
                fontWeight: 600,
                fontSize: '20px',
                color:
                  activeItem === item.route ? '#808080' : '#ffffff',
                textTransform: 'none',
                '&:hover': {
                  backgroundColor: 'transparent',
                  color: '#FFFDFB',
                },
              }}
            >
              {item.label}
            </Button>
          ))}
        </Stack>

        {/* Mobile Hamburger ONLY */}
        <IconButton
          onClick={() => setMenuOpen(!menuOpen)}
          sx={{
            display: { xs: 'flex', md: 'none' },
            color: '#fff',
            zIndex: 2,
            border: '1px solid #87DFCA',
            borderRadius: '10px',
            width: 42,
            height: 42,
          }}
        >
          {menuOpen ? <CloseIcon /> : <MenuIcon />}
        </IconButton>

        {/* Mobile Dropdown Menu */}
        {menuOpen && (
          <Box
            sx={{
              position: 'absolute',
              top: 90,
              right: 16,
              width: 180,
              borderRadius: 2,
              overflow: 'hidden',
              zIndex: 50,
              background: `url(${bgGif})`,
              backgroundSize: 'cover',
              backgroundPosition: 'right',
            }}
          >
            {menuItems.map((item) => (
              <Button
                key={item.label}
                onClick={() => handleNavClick(item.route)}
                sx={{
                  width: '100%',
                  justifyContent: 'flex-start',
                  px: 3,
                  py: 1.5,
                  color:
                    activeItem === item.route ? '#87DFCA' : '#fff',
                  textTransform: 'none',
                  borderBottom: '1px solid #444',
                  '&:hover': {
                    backgroundColor: 'rgba(255,255,255,0.1)',
                  },
                }}
              >
                {item.label}
              </Button>
            ))}
          </Box>
        )}
      </Toolbar>
    </AppBar>
  );
}
